import {Box, HStack, Icon, Text, VStack} from 'platform/foundation';

import i18n from '@dms/i18n';

import {MandatoryFieldMapValue} from '../../utils/mandatoryFieldsMap';
import {DestroyDialog} from '../DestroyDialog/DestroyDialog';

interface MandatoryFieldsErrorModalProps {
  mandatoryFields: MandatoryFieldMapValue[];
  translatedFields: string[];
  onSubmit: (field: MandatoryFieldMapValue) => void;
}

export function MandatoryFieldsErrorModal(props: MandatoryFieldsErrorModalProps) {
  return (
    <DestroyDialog
      iconPath="alert_icon/circle"
      heading={i18n.t('entity.mandatoryFields.errorModal.heading')}
      description={i18n.t('entity.mandatoryFields.errorModal.description')}
      onSubmit={() => props.onSubmit(props.mandatoryFields[0])}
      onSubmitButtonTitle={i18n.t('entity.mandatoryFields.errorModal.submit')}
      onSubmitButtonVariant="primary"
      cancelButtonTitle={i18n.t('general.actions.back')}
    >
      <Box paddingVertical={6} maxWidth={100} width="100%">
        <Box
          width="100%"
          borderColor="palettes.red.70.100"
          border="1px solid"
          backgroundColor="palettes.red.10.100"
          borderRadius="medium"
          padding={4}
        >
          <HStack spacing={10}>
            <Icon color="palettes.red.70.100" value="alert/error" size={5} />
            <Text size="xSmall" color="danger">
              <VStack spacing={0}>
                {props.translatedFields.map((field) => (
                  <div key={field}>* {field}</div>
                ))}
              </VStack>
            </Text>
          </HStack>
        </Box>
      </Box>
    </DestroyDialog>
  );
}
